import { createSlice } from "@reduxjs/toolkit";
import {
  getServerStats,
  getViewsPerMonth,
  getLastComments,
  getWritersStats,
  getPostsByDay,
  getSubcategoriesStats,
  getTopPosts,
  getProfilesPostsStats,
  getLastPosts,
} from "./thunk";

const initialState = {
  serverStats: null,
  viewsPerMonth: [],
  lastComments: [],
  writersStats: [],
  postsByDay: [],
  subcategoriesStats: [],
  topPosts: [],
  profilesPostsStats: [],
  lastPosts: [],

  loading: false,
  error: null,
};

const analysisSlice = createSlice({
  name: "analysis",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // SERVER STATS
    builder
      .addCase(getServerStats.pending, (state) => {
        state.loading = true;
      })
      .addCase(getServerStats.fulfilled, (state, action) => {
        state.loading = false;
        state.serverStats = action.payload;
      })
      .addCase(getServerStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // VIEWS
    builder.addCase(getViewsPerMonth.fulfilled, (state, action) => {
      state.viewsPerMonth = action.payload;
    });

    // COMMENTS
    builder.addCase(getLastComments.fulfilled, (state, action) => {
      state.lastComments = action.payload;
    });

    // WRITERS
    builder.addCase(getWritersStats.fulfilled, (state, action) => {
      state.writersStats = action.payload;
    });

    // POSTS BY DAY
    builder.addCase(getPostsByDay.fulfilled, (state, action) => {
      state.postsByDay = action.payload;
    });

    // SUBCATEGORIES
    builder.addCase(getSubcategoriesStats.fulfilled, (state, action) => {
      state.subcategoriesStats = action.payload;
    });

    // TOP POSTS
    builder.addCase(getTopPosts.fulfilled, (state, action) => {
      state.topPosts = action.payload;
    });

    // PROFILES POSTS
    builder.addCase(getProfilesPostsStats.fulfilled, (state, action) => {
      state.profilesPostsStats = action.payload;
    });

    // LAST POSTS
    builder.addCase(getLastPosts.fulfilled, (state, action) => {
      state.lastPosts = action.payload;
    });
  },
});

export default analysisSlice.reducer;
